import { name, version } from '../package.json';

export default {
    ariaLabel: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the section heading `aria-label` attribute.',
        },
    },
    bold: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, sets the section heading text to bold.',
        },
    },
    border: {
        type: String,
        default: 'primary',
        validator(value) {
            return ['primary', 'secondary', 'tertiary', 'none'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `primary`, `secondary`, `tertiary`, `none`.',
            description: 'Sets section heading border style.',
        },
    },
    borderPosition: {
        type: String,
        default: 'top',
        validator(value) {
            return ['top', 'bottom'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `top`, `bottom`.',
            description:
                'Sets section heading border position. **This prop has been deprecated. The border is automatically positioned based on the value of `container`.**{.mds-doc-prop-table__deprecated-text}',
            deprecated: true,
        },
    },
    container: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, renders a visible container around a section.',
        },
    },
    content: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the section content.',
            support: ['v-html'],
        },
    },
    collapsible: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, enables the ability to collapse a section',
        },
    },
    expanded: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, expands a collapsible section',
        },
    },
    headingLevel: {
        type: Number,
        default: 2,
        validator(value) {
            return value >= 1 && value <= 6;
        },
        docs: {
            validation: '—',
            description: 'Sets the `<h#>` section heading level of the card title.',
        },
    },
    onDark: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, changes component to on-dark styling.',
        },
    },
    size: {
        type: Number,
        default: 5,
        validator(value) {
            return value >= 1 && value <= 9;
        },
        docs: {
            validation: 'Must be a number between `1` and `9`.',
            description:
                'Sets the section heading text size, based on [typography heading level styles](/visual-language/typography).',
        },
    },
    title: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the section section heading text.',
        },
    },
    titleDescription: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'If `true`, renders an icon-only button next to the section heading text. **This prop has been deprecated. Use `mds-section-title-description` named slot instead.**{.mds-doc-prop-table__deprecated-text}',
            deprecated: true,
        },
    },
    titleDescriptionIcon: {
        type: String,
        default: 'question-circle',
        docs: {
            validation: 'Must be a valid icon name and `titleDescription` must be `true`.',
            description:
                'Sets the icon used in the `titleDescription`. **This prop has been deprecated. Use `mds-section-title-description` named slot instead.**{.mds-doc-prop-table__deprecated-text}',
            deprecated: true,
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
